var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublishedWithChangesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413-139.5q-62-13.5-113.5-44.75t-88.5-76q-37-44.75-57.25-101T133.5-480q0-84.5 38-158.5t117-131h-128V-795H333v172.5h-25.5v-128q-76 51-112.25 121.75T159-480q0 112.5 68.75 200.25T413-166v26.5ZM423-334 292-465l18-18 113 113 227-227 18.5 18L423-334Zm204.5 169.5V-337H653v128.5Q728-260 764.75-331t36.75-149q0-112.5-69-200.25T547.5-794v-26.5q124 26 201.75 120.25T827-480q0 84.5-38.25 159T672-190h128v25.5H627.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishedWithChangesIcon);
export default __webpack_public_path__ + "static/media/PublishedWithChangesIcon.54872700c28babc8672a5f1ad67fdcc9.svg";
export { ForwardRef as ReactComponent };